import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import FraudHitEvaluatorSearchParams from './FraudHitEvaluatorSearchParams';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import AntiFraudToolService from '../../../Services/AntiFraudToolService';
import FraudHitEvaluatorItem from '../../../Domain/FraudHitEvaluatorItem';
import FraudHitEvaluatorFraudStatusChangeWindowDescription from './FraudHitEvaluatorFraudStatusChangeWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import ShowMatchesOverDataWindow from './ShowMatchesOverDataWindow';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import textHelper from '../../../Helpers/textHelper';

export default class FraudHitEvaluatorTab extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const searchParams = new FraudHitEvaluatorSearchParams();
    if (props.selectedFraudStatuses) searchParams.SelectedFraudStatuses = props.selectedFraudStatuses;
    if (props.fraudHitId) searchParams.FraudHitId = props.fraudHitId;
    if (props.evaluatorId) searchParams.EvaluatorId = props.evaluatorId;

    this.state = {
      itemList: [],
      searchItem: searchParams,
      shownPanel: ShownPanelsEnum.None,
      selectedFraudHitEvaluator: null,
    };

    this.startSearch = this.startSearch.bind(this);
    this.closeOverWindow = this.closeOverWindow.bind(this);
    this.clickOnCancel = this.clickOnCancel.bind(this);
    FraudHitEvaluatorItem.matrixFunction = this.matrixFunction.bind(this);
    FraudHitEvaluatorItem.fraudStatusChangeFunction = this.fraudStatusChangeFunction.bind(this);
    FraudHitEvaluatorItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    FraudHitEvaluatorItem.selectedStatus = this.selectedStatus.bind(this);
    FraudHitEvaluatorItem.clickOnSelect = this.clickOnSelect.bind(this);
    this.massFraudStatusChangeFunction = this.massFraudStatusChangeFunction.bind(this);
  }

  matrixFunction(fraudHitEvaluator) {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.MatchList,
      selectedFraudHitEvaluator: fraudHitEvaluator,
    });
  }

  renderPanels() {
    if (this.state.shownPanel === ShownPanelsEnum.StatusUpdate) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={{
            FraudHitEvaluatorId: this.state.selectedFraudHitEvaluator.FraudHitEvaluatorId,
            FraudStatus: this.state.selectedFraudHitEvaluator.FraudStatus,
            PendingOnId: this.state.selectedFraudHitEvaluator.PendingOnId,
            IsNewlyDetected:
              this.state.selectedFraudHitEvaluator.PendingOnId == null &&
              this.state.selectedFraudHitEvaluator.FraudStatus === 'Detected',
            DeactivationEmailSubject: textHelper.getDeactivationEmailSubject(this.state.selectedFraudHitEvaluator.ShopperId),
            //Todo: Refactor it to get the data from a helper
            DeactivationEmailBody: textHelper.getDeactivationEmailBody(this.state.selectedFraudHitEvaluator.ShopperId),
          }}
          clickOnCancel={() => this.clickOnCancel()}
          clickOnSave={() => this.clickOnCancel()}
          windowDescription={FraudHitEvaluatorFraudStatusChangeWindowDescription}
        />
      );
    }
    if (this.state.shownPanel === ShownPanelsEnum.MassStatusUpdate) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={{
            FraudHitEvaluatorId: this.getSelectedId(),
            EvaluatorIds: this.getSelectedShopperIdsAndNames(),
            FraudStatus: 'Under Investigation',
            PendingOnId: null,
            IsNewlyDetected: true,
            DeactivationEmailSubject: textHelper.getDeactivationEmailSubject(),
            //Todo: Refactor it to get the data from a helper, if possible same az above
            DeactivationEmailBody: textHelper.getDeactivationEmailBody(this.getSelectedShopperIdsAndNames()),
          }}
          clickOnCancel={() => this.clickOnCancel()}
          clickOnSave={() => this.clickOnCancel()}
          windowDescription={FraudHitEvaluatorFraudStatusChangeWindowDescription}
        />
      );
    }
  }

  clickOnCancel() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      selectedFraudHitEvaluator: null,
      searchItem: { ...this.state.searchItem },
    });
  }

  componentDidMount() {}

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  fraudStatusChangeFunction(fraudHitEvaluator) {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedFraudHitEvaluator: fraudHitEvaluator,
    });
  }

  closeOverWindow() {
    this.setState({ shownOverWindow: ShownOverWindowsEnum.None });
  }

  selectAllElements() {
    const selectedStatus = this.state.itemList.some((item) => item.Selected === false);

    const templist = [...this.state.itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ itemList: templist });
  }

  selectedStatus() {
    return !this.state.itemList.some((x) => x.Selected === false);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  getSelectedId(){
    const selectedShoppersId = this.state.itemList
    .filter((x) => x.Selected === true)
    .map((x) => `${x.FraudHitEvaluatorId}`)
    .join(',');

    return selectedShoppersId;
  }

  getSelectedShopperIdsAndNames(){
    const selectedShoppers = this.state.itemList
    .filter((x) => x.Selected === true)
    .map((x) => `${x.ShopperId} - ${x.ShopperName} `);

    return selectedShoppers;
  }

  massFraudStatusChangeFunction(fraudHitEvaluator) {
    this.setState({
      shownPanel: ShownPanelsEnum.MassStatusUpdate,
    });
  }

renderButtons(item) {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              onClick: () => this.massFraudStatusChangeFunction(item),
              label: 'Change Fraud Status',
              tooltip: 'Change Fraud Status',
              roleKey: 'AntiFraudTool_ActionButton',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
          ]}
        />
      </div>
    );
  }

  clickOnSelect(item, selected) {
    item.Selected = selected;
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      if (element.FraudHitEvaluatorId === item.FraudHitEvaluatorId) {
        element.Selected = selected;
      }
    });
    this.setState({ itemList: templist });
  }

  renderOverWindows() {
    if (this.state.shownOverWindow === ShownOverWindowsEnum.MatchList) {
      return (
        <ShowMatchesOverDataWindow
          fraudHitId={this.props.fraudHitId}
          fraudHitEvaluatorId={this.state.selectedFraudHitEvaluator.FraudHitEvaluatorId}
          fraudHitEvaluatorBaseEmail={this.state.selectedFraudHitEvaluator.ShopperEmail}
          fraudHitEvaluatorBaseName={this.state.selectedFraudHitEvaluator.ShopperName}
          clickOnCancel={this.closeOverWindow}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderPanels()}
        {this.renderOverWindows()}
        {this.renderButtons()}
        <TabOfDataTable
          type={FraudHitEvaluatorItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={AntiFraudToolService.GetAllEvaluatorsBySearching}
          convertDBItemsFunction={AntiFraudToolService.ConvertHitEvaluatorDBItemList}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={'Id'}
          showSearchStrip={true}
          searchParamsType={FraudHitEvaluatorSearchParams}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          errorCode='FHET43'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
        />
      </div>
    );
  }
}
